// extracted by mini-css-extract-plugin
export default {"section-container":"SectionContainer_section-container__rh23S"};